import { render, staticRenderFns } from "./AccreditationDeleteDialog.vue?vue&type=template&id=56c58868&scoped=true&"
import script from "./AccreditationDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./AccreditationDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationDeleteDialog.vue?vue&type=style&index=0&id=56c58868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c58868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VBtn,VCard,VDialog,VIcon,VProgressLinear})
